import React, { useContext, useEffect } from 'react';  
import { Button } from '@mui/material';  
import '../Styles/StringOutput.css';  
import '../Styles/index.css';  
import { CreateSubscribedTopicString } from '../Utils/CreateSubscribedTopicString.js';  
import { CreatePublishedTopicString } from '../Utils/CreatePublishedTopicString.js';  
import { AppContext } from '../Utils/Context.js';  
import { CustomWarningToast } from '../Utils/ToastMessages.js';  
import { Toaster, toast } from 'react-hot-toast';  
  
const StringOutput = () => {  
  const {  
  subscribedTopicString,  
  activeTab,  
  activeDataChip,  
  publishedTopicString,  
  setPublishedTopicString,  
  setSubscribedTopicString,  
  columnData,  
  } = useContext(AppContext);  
  
  const handleClickGenerate = () => {  
  const subscribedTopicString = CreateSubscribedTopicString(activeTab, activeDataChip);  
  
  if (activeTab === 'demo') {  
  setSubscribedTopicString(subscribedTopicString);  
  return;  
  }  
  
  const emptyColumnIndex = findEmptyColumnIndex(columnData);  
  
  if (emptyColumnIndex === -1) {  
  setSubscribedTopicString(subscribedTopicString);  
  return;  
  }  
  
  setPublishedTopicString('');  
  setSubscribedTopicString('');  
  notify(3000, emptyColumnIndex);  
  };  
  
  const findEmptyColumnIndex = (columnData) => {  
  return columnData.findIndex((item, index) => {  
  const hasDataBefore = columnData.slice(0, index).some((col) => col.columnData.length > 0);  
  const hasDataAfter = columnData.slice(index + 1).some((col) => col.columnData.length > 0);  
  return hasDataBefore && item.columnData.length < 1 && hasDataAfter;  
  });  
  };  
  
  const notify = (duration = 3000, emptyColumnIndex) => {  
  toast.custom((t) => (  
  <CustomWarningToast  
    emptyColumnIndex={emptyColumnIndex}  
    onClose={() => toast.dismiss(t.id)}  
    duration={duration}  
  />  
  ), {  
  duration,  
  });  
  };  
  
  useEffect(() => {  
  CreatePublishedTopicString(setPublishedTopicString, subscribedTopicString, columnData);  
  }, [subscribedTopicString, setPublishedTopicString, columnData]);  
  
  const getCharacterLength = (string) => {  
  const cleanedString = string.replace(/[\s/]/g, '');  
  return cleanedString.length;  
  };  
  
  return (  
  <div className="content-container">  
  <div className="topic-blocks">  
    {/* Published Topic */}  
    <div className="publisher-block">  
    <div className="block-title">  
    <h3>Producer publishes to:</h3>  
    <div className="character-counter">  
      <p>Characters: {publishedTopicString ? getCharacterLength(publishedTopicString) : 0} / 200</p>  
    </div>  
    </div>  
    <div className="publisher-text-block">  
    {publishedTopicString ? (  
      <p className="published-topic-body">{publishedTopicString}</p>  
    ) : (  
      <p className="published-topic-body">Press "Generate" to get started.</p>  
    )}  
    </div>  
    </div>  
  
    {/* Subscriber Topic */}  
    <div className="subscriber-block">  
    <div className="block-title">  
    <h3>Consumer subscribes to:</h3>  
    <div className="character-counter">  
      <p>Characters: {subscribedTopicString ? getCharacterLength(subscribedTopicString) : 0} / 200</p>  
    </div>  
    </div>  
    <div className="subscriber-text-block">  
    {subscribedTopicString ? (  
      <p className="topic-string-text">{subscribedTopicString}</p>  
    ) : (  
      <p>Press "Generate" to get started.</p>  
    )}  
    </div>  
    </div>  
  </div>  
  
  <div className="button-container">  
    <Button  
    variant="contained"  
    sx={{  
    backgroundColor: 'var(--primary-color)',  
    width: '15rem',  
    color: 'white',
    fontWeight: 'bold',
    fontFamily: 'Arial',
    padding: '10px 20px',  
    '&:hover': {  
      backgroundColor: '#009C74',  
    },  
    }}  
    onClick={handleClickGenerate}  
    >  
    Generate  
    </Button>  
  </div>  
  <Toaster />  
  </div>  
  );  
};  
  
export default StringOutput;
